export const PageTypes = {
  login: "login",
  claims: "claims",
  cover: "cover",
  help: "help",
  contactus: "contactus",
  healthsupport: "healthsupport",
  homepage: "homepage",
  inbox: "inbox",
  profile: "profile",
  notifications: "notifications",
  paymentdetails: "paymentdetails",
  howtoclaim: "howtoclaim",
  makeaclaim: "makeaclaim",
  loggedout: "loggedout",
  logoutredirect: "logoutredirect"
};

export const ProductTypes = {
  healthinsurance: "healthinsurance",
  businesshealthselect: "businesshealthselect",
  doctorathand: "doctorathand",
  livesmart: "livesmart",
  advance: "advance",
  asktheexpert: "asktheexpert",
  healthunlocked: "healthunlocked",
  activeplus: "activeplus"
};

export const GoogleTagManagerConstants = {
  eventTypes: {
    updateContactDetailsEvent: "mol-col-update-contact-details",
    receiveDocumentsPreferenceChangeEvent: "mol-col-update-output-choice",
    failedToSendGoogleAnalyticsEvent: "failedToSendGoogleAnalyticsEvent"
  },
  dataLayerWasNotDefined: "Google data layer was not defined",
  pageTypes: PageTypes,
  productTypes: ProductTypes
};
